<app-topnav [llttfPage]="llttfPage"></app-topnav>

<div class="container">
  <div class="content" role="main">
    <div class="cmha-dashboard">
      <div class="participant-banner" [ngClass]="participantClassByRole">
        <div class="container">
          <h2>{{'editMyPlanText'|translate:translations}}</h2>
        </div>
      </div>
      <div class="h-30"></div>
      <div class="container">
        <div class="mb-10"></div>
        <app-plan-details-form [planDetails]="planDetails" [isSubmitted]="isSubmitted"></app-plan-details-form>
        <div class="mb-10"></div>
        <div class="form-buttons">
          <button type="submit" class="submit-form-button" (click)="updatePlan()" [ngClass]="participantClassByRole">{{'submitButtonText'|translate:translations}}</button>
          <a class="submit-form-button cancel-button" href="/dashboard-participant">{{'cancelButtonText'|translate:translations}} </a>
        </div>
      </div>

      <div class="h-30"></div>
    </div>
  </div>
</div>

<app-footer [bbapp]="true"></app-footer>
